import * as ngCommon from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Material Modules
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
// End

// Kendo modules
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
//End

import { ToastrModule } from 'ngx-toastr';
import { UtilsModule } from '../../app-core/utils.module';


@NgModule({
	imports: [
		ngCommon.CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		HttpClientModule,
		UtilsModule,
		MatMenuModule,
		MatInputModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCheckboxModule,
		MatRadioModule,
		MatDialogModule,
		MatExpansionModule,
		MatDatepickerModule,
		MatBadgeModule,
		MatSlideToggleModule,
		MatTooltipModule,
		MatTabsModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatIconModule,
		MatChipsModule,
		MatSidenavModule,
		MatPaginatorModule,
		MatRippleModule,
		ButtonsModule,
		DateInputsModule,
		DialogModule,
		DropDownsModule,
		MultiSelectModule,
		ExcelExportModule,
		ExcelModule,
		GridModule,
		InputsModule,
		IntlModule,
		LabelModule,
		PDFExportModule,
		PopupModule,
		TreeViewModule,
		ToastrModule.forRoot({
			closeButton: true,
			progressBar: false,
			progressAnimation: 'increasing',
			positionClass: 'toast-top-right',
			timeOut: 1000,
			preventDuplicates: true,
		}),
	],
	declarations: [],
	exports: [
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		HttpClientModule,
		UtilsModule,
		MatMenuModule,
		MatInputModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCheckboxModule,
		MatRadioModule,
		MatDialogModule,
		MatExpansionModule,
		MatDatepickerModule,
		MatBadgeModule,
		MatSlideToggleModule,
		MatTooltipModule,
		MatTabsModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatIconModule,
		MatChipsModule,
		MatSidenavModule,
		MatPaginatorModule,
		MatRippleModule,
		ButtonsModule,
		DateInputsModule,
		DialogModule,
		DropDownsModule,
		MultiSelectModule,
		ExcelExportModule,
		ExcelModule,
		GridModule,
		InputsModule,
		IntlModule,
		LabelModule,
		PDFExportModule,
		PopupModule,
		TreeViewModule,
	],
	providers: [ngCommon.DatePipe],
})
export class AppCommonModule {
	static forRoot() {
		return {
			ngModule: AppCommonModule,
			providers: [],
		};
	}
}
